// Header
(() => {
  function handleDrawerClick(evt) {
    const panel = evt.target.closest('.panel')?.nextElementSibling;

    if (!panel || !panel?.nextElementSibling?.classList.contains('panel')) {
      return;
    }

    const buttons = panel.querySelectorAll('button:has(.circle-chevron)');

    if (!buttons.length) {
      return;
    }

    setTimeout(() => {
      buttons[0].click();
    }, 5);
  }

  function handleDrawerBackClick(evt) {
    const panel = evt.target.closest('.panel')?.previousElementSibling;

    if (!panel || !panel?.previousElementSibling?.classList.contains('panel')) {
      return;
    }

    const button = panel.querySelector('button:has(.icon-chevron-left)');

    if (!button) {
      return;
    }

    setTimeout(() => {
      button.click();
    }, 5);
  }

  document.querySelectorAll('navigation-drawer .panel:first-child button:has(.circle-chevron)').forEach((button) => {
    button.addEventListener('click', handleDrawerClick);
  });

  document.querySelectorAll('navigation-drawer .panel:last-child button:has(.icon-chevron-left)').forEach((button) => {
    button.addEventListener('click', handleDrawerBackClick);
  });
})();